import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import { useRouter } from 'next/router'
import { Chapter } from 'src/@core/utils/types'

export type BookChapterSelectProps = {
  chapterList: Chapter[]
  selectedChapter: number
}

const BookChapterSelect = ({ chapterList, selectedChapter }: BookChapterSelectProps) => {
  const router = useRouter()

  if (chapterList.length === 0) {
    return null
  }

  return (
    <Stack direction={'column'} spacing={4} sx={{ width: '100%' }}>
      <FormControl fullWidth>
        <InputLabel id='book-chapter-simple-select-label'>Chapter</InputLabel>
        <Select
          labelId='book-chapter-simple-select-label'
          id='book-chapter-simple-select'
          value={chapterList?.[selectedChapter - 1]?.key || ''}
          label='Chapter'
          onChange={e => router.push(`/book/${e.target.value}`)}
        >
          {chapterList.map((chapter, idx) => (
            <MenuItem key={idx} value={chapter.key}>
              <a href={`/book/${chapter.key}`} onClick={e => e.preventDefault()} style={{textDecoration: 'none', color: 'inherit'}}>
                {chapter.header}
              </a>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  )
}

export default BookChapterSelect
